import { render } from "./ListaCompra.vue?vue&type=template&id=555b21d6&scoped=true"
import script from "./ListaCompra.vue?vue&type=script&lang=js"
export * from "./ListaCompra.vue?vue&type=script&lang=js"

import "./ListaCompra.vue?vue&type=style&index=0&id=555b21d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555b21d6"]])

export default __exports__